import React, { Component } from 'react'

export class RegisterPage extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default RegisterPage
